import { useEffect } from "react";
import api from "../utils/api";

/**
 * Hook para fazer prefetch dos dados do chat
 * Carrega os dados em background quando o componente é montado
 *
 * CRITICAL: Requires sessionId to work with chat_threads mode
 */
export const useChatPrefetch = (sessionId?: string | null) => {
  useEffect(() => {
    // ✅ CRITICAL: Don't prefetch without sessionId
    // Backend returns 400 when USE_CHAT_THREADS=true and sessionId is missing
    if (!sessionId) {
      return;
    }

    const prefetchChats = async () => {
      try {
        const payload = {
          filter: "",
          sessionId, // ✅ Always include sessionId
        };

        if ("requestIdleCallback" in window) {
          (window as any).requestIdleCallback(() => {
            api.post("/api/get-chats", payload).catch(() => {
              // Prefetch failure is non-critical, silently ignore
            });
          });
        } else {
          setTimeout(() => {
            api.post("/api/get-chats", payload).catch(() => {
              // Prefetch failure is non-critical, silently ignore
            });
          }, 100);
        }
      } catch (error) {
        // Prefetch errors are non-critical
      }
    };
    prefetchChats();
  }, [sessionId]); // Re-run if sessionId changes
};

export default useChatPrefetch;
